import SectionSubGroup from "@components/SectionGroup/SectionSubGroup"
import { AuthContext } from "@providers/AuthProvider"
import { DEFAULT_LANG } from "@utils/Constants"
import { useMobileMediaQuery } from "@utils/MediaComponents"
import { Item } from "cs.node.utils/csapi/provisioning"
import { SearchResultItemSkuParent } from "cs.node.utils/SearchUtils"
import { useContext } from "react"
import { Badge } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

type Props = {
    content: SearchResultItemSkuParent
}

const HeaderSearchBarResultItem = (props: Props) =>{
    const {content} = props
    const auth = useContext(AuthContext)
    const navigate = useNavigate()
    const isMobile = useMobileMediaQuery()

    const lang = auth.userData.defaultLang ?? DEFAULT_LANG
    const { sku_parent, items } = content
    const itemHeader:Item = items[0]
    const { props:itemProps={}, locs={}, imgs=[] } = itemHeader
    const { brand="", season } = itemProps
    const { singles={} } = locs
    const { title={} } = singles

    const itemTitle = title[lang] ?? title[DEFAULT_LANG] ?? "N.D."
    const image = imgs.find(img=>img.placement?.[0] === "LIST")?.url ?? imgs?.[0]?.url ?? '/images/no-image.png'

    if(isMobile) {
        return <div className="my-2 py-4 w-100" style={{borderBottom: '1px dashed var(--bs-gray-gray-300'}} onClick={(e)=>{
            if(!sku_parent) {
                return
            }
            const link = `/catalog/${encodeURIComponent(sku_parent)}`
            
            if(e?.metaKey || e?.ctrlKey) {
                window.open(link, "_blank");
            } else{
                navigate(link)
            }
        }}>
            <div className="row w-100">
                <div className="col-4 d-flex align-items-center justify-content-start">
                    <img src={image} alt={image} style={{height: "40px", width: '40px'}} />
                </div>
                <div className="col-20 d-flex flex-column align-items-start justify-content-start">
                    <span className="fw-bold cs-link">{sku_parent ?? "N.D."}</span>
                    <span className="text-muted">{itemTitle}</span>
                    <span className="text-muted">{`${brand} / ${season}`}</span>
                </div>
            </div>
            <div className="w-100 overflow-y-auto w-auto mt-4">
                {items.map((item:Item)=>{
                    const { props={} } = item
                    const { size="" } = props
                    const totalQty = item.abs?.reduce((prev, curr)=>{
                        return prev += (curr.qty ?? 0)
                    },0) ?? 0

                    const totalQtyColor = totalQty<=0?"danger": (totalQty === 1 ? "warning": "success")

                    return <Badge role="button" key={`search_bar_result_item_${item.item_id?.$oid}`} bg={totalQtyColor} className="p-2 me-2 mb-2 fs-5 fade-hover text-decoration-underline" onClick={(e)=>{
                        if(!sku_parent) {
                            return
                        }
                        
                        const link = `/catalog/${encodeURIComponent(sku_parent)}?t=7&sku=${encodeURIComponent(item.sku!)}`

                        if(e?.metaKey || e?.ctrlKey) {
                            window.open(link, "_blank");
                        } else{
                            navigate(link)
                        }
                    }}>
                        {`${size} : ${totalQty?.toFixed(0)}`}
                    </Badge>
                })}
            </div>
        </div>
    }

    return <SectionSubGroup small className="w-100">
        <div className="d-flex align-items-center justify-content-start">
            <div role="button" className="d-flex align-items-center justify-content-start me-4" onClick={(e)=>{
                if(!sku_parent) {
                    return
                }
                const link = `/catalog/${encodeURIComponent(sku_parent)}`
                
                if(e?.metaKey || e?.ctrlKey) {
                    window.open(link, "_blank");
                } else{
                    navigate(link)
                }
            }}>
                <div className="p-2">
                    <img src={image} alt={image} className="m-2" style={{maxHeight: "60px", maxWidth: '60px'}} />
                </div>
                <div className="d-flex flex-column align-items-start justify-content-start">
                    <span className="fw-bold cs-link">{sku_parent ?? "N.D."}</span>
                    <span className="text-muted">{itemTitle}</span>
                    <span className="text-muted">{`${brand} / ${season}`}</span>
                </div>
            </div>
            <div className="overflow-y-auto w-auto">
                {items.map((item:Item)=>{
                    const { props={} } = item
                    const { size="" } = props
                    const totalQty = item.abs?.reduce((prev, curr)=>{
                        return prev += (curr.qty ?? 0)
                    },0) ?? 0

                    const totalQtyColor = totalQty<=0?"danger": (totalQty === 1 ? "warning": "success")

                    return <Badge role="button" key={`search_bar_result_item_${item.item_id?.$oid}`} bg={totalQtyColor} className="p-2 me-2 mb-2 fs-5 fade-hover" onClick={(e)=>{
                        if(!sku_parent) {
                            return
                        }
                        
                        const link = `/catalog/${encodeURIComponent(sku_parent)}?t=7&sku=${encodeURIComponent(item.sku!)}`

                        if(e?.metaKey || e?.ctrlKey) {
                            window.open(link, "_blank");
                        } else{
                            navigate(link)
                        }
                    }}>
                        {`${size} : ${totalQty?.toFixed(0)}`}
                    </Badge>
                })}
            </div>
        </div>

    </SectionSubGroup>
}

export default HeaderSearchBarResultItem